import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { checkAuth } from 'features/user';




// import DashboardPage from 'containers/DashboardPage';
// import LoginPage from 'containers/LoginPage';
// import RegisterPage from 'containers/RegisterPage';




//import HomePage from 'containers/HomePage';
import HomePage from 'pages_public/HomePage';
import LoginPage from 'pages_auth/LoginPage';
import RegisterPage from 'pages_auth/RegisterPage';
import DashboardPage from 'pages_auth/DashboardPage';

import AWordFromCharles from 'pages_public/AWordFromCharles';
//import RobertGoddard from 'pages_public/RobertGoddard';
import SiteMap from 'pages_public/SiteMap';

import Template from 'template/Template';


// import Contact from 'pages_public/Contact';
import Calendar from 'pages_public/Calendar';
// import Donate from 'pages_public/Donate';
import Initiatives from 'pages_public/Initiatives';
import GoddardCenter from 'pages_public/GoddardCenter';


import MessageBoard from 'pages_auth/MessageBoard';
import Settings from 'pages_auth/Settings';


import DigitalVisibilityPage from 'pages_public/DigitalVisibilityPage';


import FriendsOfGoddard from 'pages_public/FriendsOfGoddard';




import Centennial from 'pages_public/Centennial';







import CentennialPage_V2 from 'pages_centennial/CentennialPage';



import CentennialPageRefactor from 'centennial_refactor/CentennialPageRefactor';

//import DonateSuccess from 'pages_public/DonateSuccess';





// REFACTORED IMPORTS
import NewsletterForm from 'pages_public/NewsletterForm';

import CentennialPageRefactorAboutPage from 'centennial_refactor/CentennialPageRefactorAbout'; 

import RobertGoddard from 'centennial_refactor/RobertGoddard';

import Donate from 'centennial_refactor/Donate';

import Contact from 'centennial_refactor/Contact';

import DonateSuccess from 'centennial_refactor/DonateSuccess';






const App = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(checkAuth());
	}, []);

	return (
		<Router>
			<Routes>


			<Route path='/' element={<CentennialPageRefactor />} />

			<Route path='/about' element={<CentennialPageRefactorAboutPage />} />
			
			<Route path='/Contact' element={<Contact />} />
				<Route path='/Donate' element={<Donate />} />

				<Route path='/donation-success' element={<DonateSuccess />} />

				
				<Route path='/RobertGoddard' element={<RobertGoddard />}  />

			{/* <Route path='/' element={<CentennialPage_V2 />} /> */}


			{/* <Route path='/' element={<NewsletterForm />} /> */}


				{/* <Route path='/home' element={<HomePage />} /> */}
				{/* <Route path='/dashboard' element={<DashboardPage />} /> */}


				{/* <Route path='/login' element={<LoginPage />} />
				<Route path='/register' element={<RegisterPage />} />
				<Route path='/dashboard' element={<DashboardPage />} />


				<Route path='/sitemap' element={<SiteMap />} />
				<Route path='/AWordFromCharles' element={<AWordFromCharles />} />
				

				<Route path='/template' element={<Template />} />



				<Route path='/Calendar' element={<Calendar />} />
				<Route path='/GoddardCenter' element={<GoddardCenter />} />
				
				<Route path='/Initiatives' element={<Initiatives />} />
				<Route path='/MessageBoard' element={<MessageBoard />} />
				<Route path='/Settings' element={<Settings />} />


				<Route path='/searchengineoptimization' element={<DigitalVisibilityPage />} />

				<Route path='/centennial' element={<Centennial />} />
				<Route path='/friendsofgoddard' element={<FriendsOfGoddard />} />
				

				<Route path='/v2' element={<CentennialPage_V2 />} />

				 */}
				

			</Routes>
		</Router>
	);
};

export default App;

